import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

export const VERIFICATION_PRODUCT_AREA = 'Growth';
export const VERIFICATION_PRODUCT_SUBAREA = 'Account Verification';

export const EVENTS = Object.freeze({
  PAGE_VIEWED: 'Page Viewed',
  OBJECT_CLICKED: 'Object Clicked',
});

export const SUBJECTS = Object.freeze({
  ACCOUNT_VERIFICATION: 'Account Verification',
  RESEND_EMAIL: 'Resend Email Verification',
});

export const trackEvent = segmentioActions.recordTrack;

export default trackEvent;
